import { Info } from 'lucide-react';
import { useEffect, useRef } from 'react';
import type { ChatMessage } from '@/entities/chat-message';
import LoadingAnimation from './LoadingAnimation';
import { Message } from './Message';

interface MessagesListProps {
  messages: ChatMessage[];
  className?: string;
  isLoading?: boolean;
  errorMessage?: string;
  onAddToPlan?: (messageId: string, blockIndex: number) => void;
  onSkip?: (messageId: string, blockIndex: number) => void;
  disabled?: boolean;
}

export function MessagesList({
  messages,
  className,
  isLoading = false,
  errorMessage,
  onAddToPlan,
  onSkip,
  disabled,
}: MessagesListProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, errorMessage]);

  return (
    <div className={`flex flex-col space-y-4 py-3 ${className || ''}`}>
      {messages.map((message) => (
        <Message
          key={message.id}
          message={message}
          onAddToPlan={onAddToPlan}
          onSkip={onSkip}
          disabled={disabled}
        />
      ))}
      {isLoading && <LoadingAnimation key="loading" />}
      {!isLoading && errorMessage && (
        <div className="text-xs text-gray-600">
          <Info className="inline h-3.5 w-3.5 align-[-0.15em]" />{' '}
          <span className="font-medium italic">{errorMessage}</span>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
}
